/*
  AMANA — wishlist native (remplace l'app Swish / Wishlist King).

  Stockage : localStorage `amana-wishlist` = { v: 1, items: [{ h, id, v, t }] }
  (handle, id produit, id variante, date d'ajout). Mode « produit » comme Swish :
  un produit n'apparaît qu'une fois, le plus récent en tête.

  Serveur (cfg.api, service amana-wishlist-api) : la copie locale sert l'affichage immédiat ;
  chaque ajout/retrait part dans une file (`amana-wishlist-pending`) envoyée à POST /v1/sync,
  qui renvoie la liste de référence. Identité : appareil anonyme (`amana-wishlist-device`, UUID)
  ou cliente connectée (cfg.customerToken, signé par Shopify). À la connexion, la liste de
  l'appareil rejoint celle du compte ; à la déconnexion, l'appareil oublie la liste de la cliente.
  Sans serveur joignable, tout continue en local et la file part au passage suivant.

  Points d'entrée dans le thème :
  - [data-amana-wishlist-button] : cœur des cartes, bouton de fiche produit, cœur du panier
    (data-handle, data-product-id, data-variant-id, data-title, data-price, data-vendor) ;
  - [data-amana-wishlist-count] : compteur de l'en-tête ;
  - [data-amana-wishlist-page] : page /pages/ma-wishlist (section amana-wishlist),
    qui rend chaque produit avec la section amana-wishlist-card (Section Rendering API).
  API publique : window.AmanaWishlist.{ has, add, remove, toggle, items, count, refresh }.
  Événement : `amana:wishlist:change` sur document ({ detail: { action, handle, items } }).
*/
(function () {
  'use strict';
  if (window.AmanaWishlist) return;

  var KEY = 'amana-wishlist';
  var IMPORT_KEY = 'amana-wishlist-swish-import';
  var MAX_ITEMS = 100;
  var SHARE_PARAM = 'liste';
  var GA4_ID = 'G-45ZR144L2K';
  var cfg = window.AmanaWishlistConfig || {};
  var str = cfg.strings || {};
  var root = (cfg.root || '/').replace(/\/?$/, '/');
  var page = null;
  // Même règle que le serveur : minuscules, chiffres, tirets. Tout le reste est ignoré.
  var HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/;
  function validHandle(h) { return typeof h === 'string' && HANDLE.test(h); }
  var API = (cfg.api || '').replace(/\/$/, '');
  var DEVICE_KEY = 'amana-wishlist-device';
  var PENDING_KEY = 'amana-wishlist-pending';
  var OWNER_KEY = 'amana-wishlist-owner';
  var SYNCED_KEY = 'amana-wishlist-synced';
  var RESYNC_MS = 120000;
  var owner = cfg.customerToken && cfg.customer ? 'c:' + cfg.customer : 'device';

  // ---------------------------------------------------------------- stockage
  function read() {
    try {
      var data = JSON.parse(window.localStorage.getItem(KEY));
      return data && Array.isArray(data.items) ? data.items.filter(function (i) { return i && validHandle(i.h); }) : [];
    } catch (e) { return []; }
  }
  function write() {
    try { window.localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items })); } catch (e) {}
  }
  var items = read();

  // Déconnexion (ou autre compte) détectée dès le chargement, avant tout affichage :
  // l'appareil ne montre jamais la liste de la cliente précédente.
  var forgotPrevious = false;
  (function () {
    if (!API) return;
    var previous = readJSON(OWNER_KEY, null);
    if (previous && previous !== 'device' && previous !== owner) {
      items = [];
      write();
      writeJSON(PENDING_KEY, []);
      forgotPrevious = true;
    }
  })();

  function toInt(v) { var n = parseInt(v, 10); return isNaN(n) ? null : n; }

  function indexOf(handle, id) {
    for (var i = 0; i < items.length; i++) {
      if ((handle && items[i].h === handle) || (id && items[i].id && String(items[i].id) === String(id))) return i;
    }
    return -1;
  }
  function has(handle, id) { return indexOf(handle, id) > -1; }

  function emit(action, handle) {
    paint();
    try {
      document.dispatchEvent(new CustomEvent('amana:wishlist:change', { detail: { action: action, handle: handle, items: items.slice() } }));
    } catch (e) {}
  }

  function add(p, opts) {
    if (!p || !validHandle(p.h)) return false;
    if (has(p.h, p.id)) return true;
    var entry = { h: p.h, id: toInt(p.id), v: toInt(p.v), t: Date.now() };
    items.unshift(entry);
    if (items.length > MAX_ITEMS) items.length = MAX_ITEMS;
    write();
    queue({ op: 'add', h: entry.h, id: entry.id, v: entry.v, t: entry.t });
    if (!(opts && opts.silent)) track('add_to_wishlist', p);
    emit('add', p.h);
    return true;
  }
  function remove(handle, id) {
    var i = indexOf(handle, id);
    if (i < 0) return false;
    var h = items[i].h;
    items.splice(i, 1);
    write();
    queue({ op: 'remove', h: h, t: Date.now() });
    emit('remove', h);
    return true;
  }

  // ------------------------------------------------------ synchronisation
  function readJSON(key, fallback) {
    try { var v = JSON.parse(window.localStorage.getItem(key)); return v == null ? fallback : v; } catch (e) { return fallback; }
  }
  function writeJSON(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    var b = new Uint8Array(16);
    window.crypto.getRandomValues(b);
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }
  function deviceId() {
    var id = readJSON(DEVICE_KEY, null);
    if (typeof id !== 'string' || !/^[0-9a-f-]{36}$/.test(id)) { id = uuid(); writeJSON(DEVICE_KEY, id); }
    return id;
  }

  var flushTimer = null;
  var inflight = null;

  function queue(op) {
    if (!API) return;
    op.k = Math.random().toString(36).slice(2, 10);
    var list = readJSON(PENDING_KEY, []);
    list.push(op);
    writeJSON(PENDING_KEY, list.slice(-200));
    window.clearTimeout(flushTimer);
    flushTimer = window.setTimeout(function () { flush(); }, 400);
  }

  // Applique localement les opérations pas encore confirmées par le serveur.
  function replay(list, ops) {
    ops.forEach(function (op) {
      var i = -1;
      for (var j = 0; j < list.length; j++) if (list[j].h === op.h) { i = j; break; }
      if (op.op === 'add' && i < 0) list.unshift({ h: op.h, id: op.id || null, v: op.v || null, t: op.t });
      if (op.op === 'remove' && i > -1) list.splice(i, 1);
    });
    return list;
  }

  // Envoie la file (et, au premier passage, la liste locale à verser). Renvoie une promesse
  // résolue même en cas d'échec : l'interface ne dépend jamais du serveur.
  function flush(opts) {
    if (!API || !window.fetch) return Promise.resolve();
    if (inflight) return inflight.then(function () { return flush(opts); });
    var sent = readJSON(PENDING_KEY, []);
    var body = { device: deviceId(), ops: sent.map(function (o) { return { op: o.op, h: o.h, id: o.id, v: o.v, t: o.t }; }) };
    if (owner !== 'device') body.customer = cfg.customerToken;
    if (opts && opts.merge && opts.merge.length) body.items = opts.merge;
    function send(b) {
      return fetch(API + '/v1/sync', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(b),
        credentials: 'omit',
        keepalive: JSON.stringify(b).length < 60000
      });
    }
    inflight = send(body)
      .then(function (r) {
        // Jeton expiré (page ouverte depuis plus d'un jour) : on garde les changements sur l'appareil,
        // ils rejoindront le compte à la prochaine page connectée.
        if (r.status === 401 && body.customer) { delete body.customer; return send(body); }
        return r;
      })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.items)) return;
        var done = {};
        sent.forEach(function (o) { done[o.k] = true; });
        var rest = readJSON(PENDING_KEY, []).filter(function (o) { return !done[o.k]; });
        writeJSON(PENDING_KEY, rest);
        var next = replay(data.items.filter(function (i) { return i && validHandle(i.h); })
          .map(function (i) { return { h: i.h, id: i.id || null, v: i.v || null, t: i.t }; }), rest);
        writeJSON(OWNER_KEY, owner);
        writeJSON(SYNCED_KEY, Date.now());
        var before = JSON.stringify(items.map(function (i) { return i.h; }));
        items = next.slice(0, MAX_ITEMS);
        write();
        if (JSON.stringify(items.map(function (i) { return i.h; })) !== before) emit('sync');
      })
      .catch(function () {})
      .then(function () { inflight = null; });
    return inflight;
  }

  // Premier échange de la page : fusion à la connexion, oubli à la déconnexion.
  // force : page wishlist, toujours à jour ; ailleurs, un échange toutes les 2 min au plus.
  function initialSync(force) {
    if (!API) return Promise.resolve();
    var previous = readJSON(OWNER_KEY, null);
    var fresh = Date.now() - readJSON(SYNCED_KEY, 0) < RESYNC_MS;
    if (!force && previous === owner && fresh && !readJSON(PENDING_KEY, []).length) return Promise.resolve();
    var merge = [];
    if (!forgotPrevious && previous !== owner) {
      // Premier passage de ce navigateur, ou connexion : la liste locale rejoint le serveur.
      merge = items.map(function (i) { return { h: i.h, id: i.id, v: i.v, t: i.t }; });
    }
    return flush({ merge: merge });
  }

  // Page quittée avant l'envoi différé : partir tout de suite (keepalive).
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden' && readJSON(PENDING_KEY, []).length) {
      window.clearTimeout(flushTimer);
      flush();
    }
  });
  function toggle(p) {
    if (has(p.h, p.id)) { remove(p.h, p.id); return false; }
    return add(p);
  }

  // ------------------------------------------------------------- analytics
  // Même règle que le tiroir panier (qikify-cart.js) : GA4 seulement, consentement respecté.
  function canTrack() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed();
    } catch (e) {}
    return true;
  }
  function track(name, p) {
    if (typeof window.gtag !== 'function' || !canTrack()) return;
    var params = { send_to: GA4_ID };
    if (name === 'add_to_wishlist') {
      var price = parseFloat(p.price);
      var item = { item_id: String(p.v || p.id || p.h), item_name: p.title || p.h };
      if (p.vendor) item.item_brand = p.vendor;
      if (!isNaN(price)) { item.price = price; params.value = price; params.currency = cfg.currency || 'EUR'; }
      params.items = [item];
    } else if (p) {
      for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) params[k] = p[k];
    }
    try { window.gtag('event', name, params); } catch (e) {}
  }

  // ------------------------------------------------------------ interface
  function fromButton(btn) {
    return {
      h: btn.getAttribute('data-handle'),
      id: btn.getAttribute('data-product-id'),
      v: btn.getAttribute('data-variant-id'),
      title: btn.getAttribute('data-title'),
      price: btn.getAttribute('data-price'),
      vendor: btn.getAttribute('data-vendor')
    };
  }

  // N'écrit dans le DOM que si la valeur change (sinon le MutationObserver boucle).
  function paintButton(btn) {
    var on = has(btn.getAttribute('data-handle'), btn.getAttribute('data-product-id'));
    if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', String(on));
    if (btn.classList.contains('is-active') !== on) btn.classList.toggle('is-active', on);
    var label = on ? str.remove : str.add;
    if (label && btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
    var text = btn.querySelector('[data-amana-wishlist-text]');
    var shown = on ? str.added : str.add;
    if (text && shown && text.textContent !== shown) text.textContent = shown;
  }

  function paint() {
    var buttons = document.querySelectorAll('[data-amana-wishlist-button]');
    for (var i = 0; i < buttons.length; i++) paintButton(buttons[i]);
    var counters = document.querySelectorAll('[data-amana-wishlist-count]');
    var n = String(items.length);
    for (var j = 0; j < counters.length; j++) {
      if (counters[j].textContent !== n) counters[j].textContent = n;
      if (counters[j].hidden !== (items.length === 0)) counters[j].hidden = items.length === 0;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-amana-wishlist-button]');
    if (!btn) return;
    // Le cœur est posé sur une carte entièrement cliquable : ne pas ouvrir la fiche.
    e.preventDefault();
    e.stopPropagation();
    var p = fromButton(btn);
    if (!p.h) return;
    if (toggle(p)) {
      btn.classList.remove('is-popping');
      void btn.offsetWidth;
      btn.classList.add('is-popping');
    }
  }, true);

  // Autre onglet : garder cœurs, compteur et page à jour.
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    items = read();
    paint();
    if (page) page.sync();
  });

  // Cartes ajoutées après coup (scroll infini, filtres, recommandations, tiroir panier).
  var paintQueued = false;
  function queuePaint() {
    if (paintQueued) return;
    paintQueued = true;
    window.requestAnimationFrame(function () { paintQueued = false; paint(); });
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-amana-wishlist-button') || n.querySelector('[data-amana-wishlist-button]'))) {
            queuePaint();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // ----------------------------------------------- reprise des listes Swish
  // Un visiteur qui avait une liste Swish (session anonyme `wk_session_id`) la retrouve une fois.
  // L'API Swish ne renvoie que des ids : /variants/<id> redirige vers /products/<handle>.
  // Ne fonctionne que tant que l'app Swish est installée ; ensuite il n'y a plus rien à reprendre.
  function importSwish() {
    var sid, state;
    try {
      sid = window.localStorage.getItem('wk_session_id');
      state = window.localStorage.getItem(IMPORT_KEY);
    } catch (e) { return Promise.resolve(); }
    if (!sid || !cfg.shop || state === 'done' || !window.fetch) return Promise.resolve();
    var tries = parseInt(state, 10) || 0;
    if (tries >= 3) return Promise.resolve();
    function mark(v) { try { window.localStorage.setItem(IMPORT_KEY, v); } catch (e) {} }
    mark(String(tries + 1));
    return fetch('https://api.appmate.io/v2/wishlists/mine', {
      headers: { 'x-appmate-shp': cfg.shop, 'x-appmate-sid': sid },
      credentials: 'omit'
    })
      .then(function (r) {
        if (r.status >= 400 && r.status < 500) { mark('done'); return null; }
        return r.ok ? r.json() : null;
      })
      .then(function (j) {
        if (!j) return null;
        var list = ((j.wishlist && j.wishlist.items) || []).slice(0, MAX_ITEMS);
        return Promise.all(list.map(function (it) {
          // Donnée tierce : uniquement un identifiant numérique, jamais un chemin arbitraire du site.
          if (!/^\d{1,20}$/.test(String(it.variantId))) return null;
          return fetch(root + 'variants/' + it.variantId, { method: 'HEAD', credentials: 'same-origin' })
            .then(function (r) {
              var m = r.ok && /\/products\/([^/?#]+)/.exec(r.url);
              return m ? { h: decodeURIComponent(m[1]), id: it.productId, v: it.variantId } : null;
            })
            .catch(function () { return null; });
        })).then(function (found) {
          // Ordre Swish conservé : le premier de sa liste reste en tête. Ajout silencieux (pas d'événement GA4).
          for (var i = found.length - 1; i >= 0; i--) {
            if (found[i]) add(found[i], { silent: true });
          }
          mark('done');
        });
      })
      .catch(function () {});
  }

  // --------------------------------------------------------- page wishlist
  function sharedHandles() {
    var raw = null;
    try { raw = new URLSearchParams(window.location.search).get(SHARE_PARAM); } catch (e) {}
    if (!raw) return null;
    var seen = {};
    var list = raw.split(',').map(function (h) { return h.trim().toLowerCase(); }).filter(function (h) {
      if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(h) || seen[h]) return false;
      seen[h] = true;
      return true;
    });
    return list.length ? list.slice(0, MAX_ITEMS) : null;
  }

  function WishlistPage(el) {
    var self = this;
    this.el = el;
    this.grid = el.querySelector('[data-amana-wl-grid]');
    this.empty = el.querySelector('[data-amana-wl-empty]');
    this.status = el.querySelector('[data-amana-wl-status]');
    this.shareBtn = el.querySelector('[data-amana-wl-share]');
    this.addAllBtn = el.querySelector('[data-amana-wl-add-all]');
    this.cards = {};
    this.rendering = null;
    this.shared = sharedHandles();
    if (this.shareBtn) this.shareBtn.addEventListener('click', function () { self.share(); });
    this.grid.addEventListener('click', function (e) {
      var x = e.target.closest && e.target.closest('[data-amana-wl-remove]');
      if (x) { e.preventDefault(); self.removeCard(x); }
    });
    if (this.addAllBtn) this.addAllBtn.addEventListener('click', function () { self.addAll(); });
    if (this.shared) {
      el.classList.add('is-shared');
      var title = el.querySelector('[data-amana-wl-title]');
      if (title && str.shared_title) title.textContent = str.shared_title;
      var shownWhenShared = el.querySelectorAll('[data-amana-wl-shared-only]');
      for (var i = 0; i < shownWhenShared.length; i++) shownWhenShared[i].hidden = false;
    }
    this.render();
  }

  WishlistPage.prototype.handles = function () {
    return this.shared || items.map(function (i) { return i.h; });
  };

  WishlistPage.prototype.render = function () {
    var self = this;
    if (this.rendering) return this.rendering;
    var handles = this.handles();
    var queue = handles.filter(function (h) { return !self.cards[h]; });
    var gone = [];
    this.grid.setAttribute('aria-busy', 'true');
    this.updateChrome();
    var running = 0;
    this.rendering = new Promise(function (resolve) {
      function next() {
        if (!queue.length && !running) { resolve(); return; }
        while (running < 6 && queue.length) {
          (function (h) {
            running++;
            self.fetchCard(h).then(function (node) {
              if (node === GONE) gone.push(h);
              else if (node) self.cards[h] = node;
            }).then(function () {
              running--;
              next();
            });
          })(queue.shift());
        }
      }
      next();
    }).then(function () {
      self.rendering = null;
      if (gone.length && !self.shared) self.dropGone(gone);
      var frag = document.createDocumentFragment();
      self.handles().forEach(function (h) { if (self.cards[h]) frag.appendChild(self.cards[h]); });
      while (self.grid.firstChild) self.grid.removeChild(self.grid.firstChild);
      self.grid.appendChild(frag);
      self.grid.setAttribute('aria-busy', 'false');
      self.updateChrome();
      paint();
    });
    return this.rendering;
  };

  // Pièce unique vendue = dépubliée : la section carte répond sans produit (ou 404 si supprimée).
  var GONE = {};

  WishlistPage.prototype.fetchCard = function (handle) {
    var url = root + 'products/' + encodeURIComponent(handle) + '?section_id=amana-wishlist-card';
    // no-cache : revalidation systématique, pour ne jamais afficher un prix ou un statut « vendu » périmé.
    return fetch(url, { credentials: 'same-origin', cache: 'no-cache' })
      .then(function (r) {
        if (r.status === 404) return GONE;
        return r.ok ? r.text() : null;
      })
      .then(function (html) {
        if (html === GONE) return GONE;
        // Erreur passagère : le produit reste dans la liste, sans être affiché cette fois.
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (doc.querySelector('[data-amana-wl-gone]')) return GONE;
        var card = doc.querySelector('[data-amana-wl-item]');
        return card ? document.importNode(card, true) : null;
      })
      .catch(function () { return null; });
  };

  // Retrait depuis la page (croix de la carte) : la carte disparaît sans recharger.
  WishlistPage.prototype.sync = function () {
    if (this.shared) { paint(); return; }
    var self = this;
    var wanted = {};
    items.forEach(function (i) { wanted[i.h] = true; });
    Object.keys(this.cards).forEach(function (h) {
      if (wanted[h]) return;
      var card = self.cards[h];
      delete self.cards[h];
      card.classList.add('is-leaving');
      window.setTimeout(function () {
        if (card.parentNode) card.parentNode.removeChild(card);
        self.updateChrome();
      }, 250);
    });
    if (items.some(function (i) { return !self.cards[i.h]; })) this.render();
    else this.updateChrome();
  };

  // Croix d'une carte : retrait immédiat, le focus passe à la croix suivante (ou précédente).
  WishlistPage.prototype.removeCard = function (x) {
    var card = x.closest('[data-amana-wl-item]');
    var near = card && (card.nextElementSibling || card.previousElementSibling);
    var target = near && near.querySelector('[data-amana-wl-remove]');
    if (!remove(x.getAttribute('data-handle'))) return;
    if (target) target.focus();
  };

  // Retire de la liste les pièces vendues ou dépubliées et le dit, pour que compteur et page concordent.
  WishlistPage.prototype.dropGone = function (handles) {
    var n = 0;
    handles.forEach(function (h) { if (remove(h)) n++; });
    if (!n) return;
    var msg = n === 1 ? str.gone_one : (str.gone_other || '').replace('{{ count }}', n);
    this.say(msg);
  };

  WishlistPage.prototype.visibleCount = function () {
    var self = this;
    return this.handles().filter(function (h) { return self.cards[h]; }).length;
  };

  WishlistPage.prototype.updateChrome = function () {
    var busy = this.grid.getAttribute('aria-busy') === 'true';
    var count = this.visibleCount();
    this.empty.hidden = busy || count > 0;
    if (this.shareBtn) this.shareBtn.hidden = !!this.shared || count === 0;
    if (this.addAllBtn) this.addAllBtn.hidden = !this.shared || count === 0;
  };

  WishlistPage.prototype.say = function (msg) {
    var s = this.status;
    if (!s || !msg) return;
    s.textContent = '';
    window.setTimeout(function () { s.textContent = msg; }, 30);
  };

  WishlistPage.prototype.shareUrl = function () {
    var u = new URL(window.location.href);
    u.search = '';
    u.hash = '';
    return u.toString() + '?' + SHARE_PARAM + '=' + items.map(function (i) { return encodeURIComponent(i.h); }).join(',');
  };

  WishlistPage.prototype.share = function () {
    var self = this;
    var url = this.shareUrl();
    if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
      navigator.share({ title: str.share_title || document.title, text: str.share_text || '', url: url })
        .then(function () { track('share', { method: 'native', content_type: 'wishlist' }); })
        .catch(function () {});
      return;
    }
    copy(url).then(function () {
      self.say(str.link_copied);
      track('share', { method: 'copy_link', content_type: 'wishlist' });
    });
  };

  WishlistPage.prototype.addAll = function () {
    var self = this;
    var n = 0;
    (this.shared || []).slice().reverse().forEach(function (h) {
      if (!self.cards[h]) return;
      var btn = self.cards[h].querySelector('[data-amana-wishlist-button]');
      var p = btn ? fromButton(btn) : { h: h };
      if (!has(p.h, p.id)) { add(p); n++; }
    });
    this.say(n ? str.added_all : str.already_all);
  };

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () { legacyCopy(text); });
    }
    legacyCopy(text);
    return Promise.resolve();
  }
  function legacyCopy(text) {
    var t = document.createElement('textarea');
    t.value = text;
    t.setAttribute('readonly', '');
    t.style.position = 'fixed';
    t.style.opacity = '0';
    document.body.appendChild(t);
    t.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(t);
  }

  document.addEventListener('amana:wishlist:change', function () { if (page) page.sync(); });

  // ------------------------------------------------------------ démarrage
  function init() {
    paint();
    var el = document.querySelector('[data-amana-wishlist-page]');
    // La page n'attend jamais plus de 4 s par étape (API Swish ou serveur lents) ; la suite finit en arrière-plan.
    function wait(p) { return Promise.race([p, new Promise(function (r) { window.setTimeout(r, 4000); })]); }
    wait(importSwish())
      .then(function () { return wait(initialSync(!!el)); })
      .then(function () { if (el && !page) page = new WishlistPage(el); });
  }

  window.AmanaWishlist = {
    has: has,
    add: function (p, opts) { return add(p, opts); },
    remove: remove,
    toggle: toggle,
    items: function () { return items.slice(); },
    count: function () { return items.length; },
    refresh: paint
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
